import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as p, S as v } from "./icons.types-0722eef5.js";
function f({ title: i, titleId: n, size: c, width: s, height: r, extended: o = !1, ...a }) {
  const h = o ? p : v, e = c ? h[c] : s || h[o ? "s" : "l"], t = c ? h[c] : r || h[o ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: e,
      height: t,
      "aria-labelledby": n,
      ...a,
      children: [
        i ? /* @__PURE__ */ l("title", { id: n, children: i }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Show_on_map_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M55.8 23.4c0-10.98-8.82-19.8-19.8-19.8s-19.8 8.82-19.8 19.8c0 6.497 2.372 9.925 5.764 14.828.461.666.94 1.36 1.436 2.092 1.438 2.237 3.372 5.147 5.283 8.022 2.396 3.605 4.755 7.156 6.057 9.258H32.4c-1.08 0-1.8.72-1.8 1.8s.72 1.8 1.8 1.8h7.2c1.08 0 1.8-.72 1.8-1.8s-.72-1.8-1.8-1.8h-2.34c.73-1.094 1.714-2.58 2.83-4.26l.001-.002v-.002c2.74-4.128 6.26-9.435 8.69-13.016a164.032 164.032 0 0 1 1.834-2.837C53.647 32.868 55.8 29.59 55.8 23.4ZM36 52.92c-.881-1.322-2.218-3.335-3.664-5.513v-.001c-3.28-4.94-7.121-10.726-7.496-11.226-3.24-4.68-5.04-7.38-5.04-12.6 0-9 7.2-16.2 16.2-16.2s16.2 7.2 16.2 16.2c0 5.05-1.684 7.572-4.726 12.13l-.314.47L36 52.92ZM27 23.4c0-5.04 3.96-9 9-9s9 3.96 9 9-3.96 9-9 9-9-3.96-9-9Zm3.6 0c0 3.06 2.34 5.4 5.4 5.4 3.06 0 5.4-2.34 5.4-5.4 0-3.06-2.34-5.4-5.4-5.4-3.06 0-5.4 2.34-5.4 5.4ZM9.9 64.8 16.2 54H27l-2.16-3.6h-10.8L3.6 68.4h64.8l-10.44-18h-10.8L45 54h10.8l6.3 10.8H9.9Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Show_on_map_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  f as ShowOnMap
};
